import { CSSObject } from "styled-components";
import { vfxTheme } from "../../../common/VFX-UI/Theme/theme";

interface campaignStyles {
  tabItem: CSSObject;
  pledgeButton: CSSObject;
}

const useCampaignStyles = (): campaignStyles => {
  
  return {
    tabItem: {
      color: vfxTheme.palette.blueGreys.bg500,
      fontFamily: vfxTheme.fontFamily,
      fontWeight: vfxTheme.fontWeights.semiBold,
      fontSize: "1.25em",
      lineHeight: "1.5rem",
    },
    pledgeButton: {
      backgroundColor: vfxTheme.palette.primary.main,
      color: vfxTheme.palette.background.default,
      marginLeft: vfxTheme.spaceUnits.sp03,
      display: "flex",
      alignItems: "center",
    },
  };
};

export default useCampaignStyles;
